<template>
    <div>
        <div class="h-toolbarBg">
            <ejs-toolbar>
              <e-items>
                <e-item  prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Common.upload")' :click='addDialog' v-if='btnVisable'></e-item>
                <e-item  prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Software.delete")' :click='remove' v-if='btnVisable' ></e-item>
              </e-items>
            </ejs-toolbar>
            <div class="h-inputBox">
                    <ejs-textbox :placeholder='$t("System.inputTip7")' @keydown.enter.native="search" v-model='input' />
            </div>
        </div>
        <div>
          <ejs-grid ref='grid' :dataSource='data' :pageSettings='pageSettings' :allowPaging='false'
            childMapping="subtasks" height="calc(100% - 0px)" :allowResizing='true'>
              <e-columns>
                  <e-column type='checkbox' minwidth ='15' width='15' ></e-column>
                  <e-column field='patchName' :headerText='$t("Software.patchName")' textAlign='Center' width="120"></e-column>
                  <e-column field='patchTag' :headerText='$t("Software.zipTag")' textAlign='Center' width="60"></e-column>
                  <e-column field='patchMadeTime' :headerText='$t("Software.patchMadeTime")' textAlign='Center' width="120"></e-column>
              </e-columns>
          </ejs-grid>
        
        </div>
        <CustomDialog ref='upload' :element='upload.element' :styles='upload.styles1'>
         <template v-slot:dialog-content>
          <AddPatchDialog ref='addObj'></AddPatchDialog>
         </template>
       </CustomDialog>
    </div>
</template>

<script>
let dataSource = [];
import { Resize } from "@syncfusion/ej2-vue-grids";
import { EventBus } from '../../plugins/eventBus';
import CustomDialog from '../../components/common/CustomDialog';
import AddPatchDialog from './addPatchDialog';


export default {
  name: 'patchverlib-list',
  components: {
    AddPatchDialog,
    CustomDialog,
  },
  data() {
    return {
      uploadProps: {status:0},
      input:'',
      btnVisable:true,
      data: [],
      pageSettings: { pageSizes: true, pageCount: 4, pageSize: 20 },
        page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
      upload: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        styles1: {
          width: '500px',
          height: '300px',
          model: true,
          visible: false,
         // zIndex: 1000,
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.confirm') } },
          ],
          title: this.$t('Common.upload')
        },
      },
    };
  },
  provide: {
      grid: [Resize]
  },
  mounted() {
      EventBus.$on('patchdialogOpen', () => {
      this.btnVisable = false;
    });
    this.queryMethod();
  },
  methods: {
    addDialog() {
      if(this.data.length >20){
         EventBus.$emit('toast', {type: 'warn', content:this.$t('Software.lte_patch_length_alert')});
         return;
      }
     EventBus.$emit('curPatchLibList', this.data);
      this.uploadProps = {status: 1};
      this.$refs.upload.show();
    },
    dialogHide() {
      if(this.uploadProps.status == 1){
        this.$refs.upload.clear();
        this.$refs.upload.close();
        this.queryMethod();
      }else{
        this.$layer.confirm({
          title: this.$t('System.tip'),
          msg: this.$t('Software.tips_cancelPatchUpload'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
              this.$refs.addObj.setCancel(1);
              this.$refs.upload.clear();
              this.$refs.upload.close();
              this.queryMethod();
            }
          },
          btn1: {
            msg: this.$t('System.cancel')
          }
        });
      }
    },
    queryMethod() {
      let para={
          versionId: '',
          pagName: '',
          verPagType: '',
          systemId: '1',
          page: {
            pageNo: 1,
            pageSize: 25,
          },
      }
      this.$axios.post('/lte/ems/verlib_new/queryPatchList', para).then((response) => {
        if(response.data.errorCode == 'SUCCESS')
        {
          dataSource = response.data.resultVal.result;
          this.data = dataSource;
        }
      });
    },
    getSelect() {
      return this.$refs.grid.getSelectedRecords();
    },
    remove() {
      const delIds = this.$refs.grid.getSelectedRecords().map(x => x.patchId +'');
      if(delIds.length == 0)
      {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("System.selectDelObj")});
        return;
      }
      this.$layer.confirm({
          msg: this.$t('LteUser.delConfirm'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
              this.$axios.post('/lte/ems/packageManager/deletePatchpkgVersion', delIds).then((response) => {
                if(response.status == 200)
                {
                  if(response.data.errorCode == 'SUCCESS')
                  {
                      EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
                  }
                  else
                  {
                      EventBus.$emit('toast', {type: 'error', content:response.data.errorString});
                  }
                }
                this.queryMethod()
              });
            }
          },
          btn1: {
            msg: this.$t('MCS.cancle')
          }
      });
    },
    search(args) {
      if(this.input === '') {
          this.data = dataSource;
      }
      else {
        var filterdata = dataSource.filter( item => {
            let columntext = Array.from(this.$refs.grid.getColumns(), x => {
              return x.field;
            });
            let feildData = Array.from(columntext, x => {
              return item[x] === null ? '' : item[x] +'';
            });
            let filres = false;
            feildData.forEach(item => {
              if(item.indexOf(this.input) > -1)
              {
                filres = true;
              }
            });
            return filres;
        }).map( item => { return item });
        this.data = filterdata;
      }
    },
    getChildProps(data) {
      this.uploadProps = data;
    },
  },
  created(){
    EventBus.$on('setChildPropsVMPatch', target => {
      this.getChildProps(target);
    });
  },
  beforeDestroy() {
    EventBus.$off('patchdialogOpen');
  }
};
</script>